import React, { useState } from "react";
import { Button, Container, Form, Badge, Offcanvas, Modal } from 'react-bootstrap';
import { Link, NavLink } from "react-router-dom";
import { FaStar, FaRegStar } from "react-icons/fa";
import dash_img from "../assets/images/man-with-laptop.png";
import Footer from '../Footer/Footer';

const ProjectsList = [
  {
    id: 1,
    protitle: "Cloud Services",
    description: "Great place to start your career...",
    logo: "https://www.veritis.com/wp-content/themes/veritis/theme/img/logo.svg",
    title: "Veritis Group Inc.",
  },
  {
    id: 2,
    protitle: "Digital Transformation Services",
    description: "Excellent workplace to showcase your skills...",
    logo: "https://www.wipro.com/content/dam/wipro/social-icons/wipro_new_logo.svg",
    title: "Wipro",
  },
];

const serviceOptions = [
  "Cloud Services", "Containerization Services", "DevOps Services", "Digital Transformation Services", "IAM Services", "Managed IT Services"
];

const MyReviews = () => {
  const [projects, setProjects] = useState(ProjectsList);
  const [selectedProject, setSelectedProject] = useState(null);
  const [showEditPanel, setShowEditPanel] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleEdit = (project) => {
    setSelectedProject({ ...project, services: [], rating: 0 });
    setShowEditPanel(true);
  };

  const handleChange = (e) => {
    setSelectedProject({ ...selectedProject, [e.target.name]: e.target.value });
  };

  const handleDelete = (project) => {
    setSelectedProject(project);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    setProjects((prev) => prev.filter((p) => p.id !== selectedProject.id));
    setShowDeleteModal(false);
  };

  const handleSaveEdit = () => {
    setProjects((prev) => prev.map((p) => (p.id === selectedProject.id ? selectedProject : p)));
    setShowEditPanel(false);
  };

  const handleServiceSelect = (service) => {
    setSelectedProject((prev) => ({
      ...prev,
      services: prev.services.includes(service)
        ? prev.services.filter((s) => s !== service)
        : [...prev.services, service]
    }));
  };

  const handleRating = (index) => {
    setSelectedProject((prev) => ({ ...prev, rating: index + 1 }));
  };

  return (
    <>
    <div className="js-pg-hg mt-4">
          <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="heading mb-3 mt-4 pb-1">
            <h4>My Reviews</h4>
          </div>
        </div>
        </div>
        </div>
      <Container className="mt-2">
        <div className="row mb-5">
          <div className="col-sm-12">
            <div className="card shadow-sm rounded-4">
              <div className="d-flex align-items-center row">
                <div className="col-sm-8">
                  <div className="card-body px-4 mx-2">
                    <h5 className="card-title text-primary mb-3">Review a Company</h5>
                    <p className="mb-6">Leaving a review helps business leaders make informed decisions.</p>
                    <Button as={Link} to="/writereview" className="btn btn-primary">Write a Review</Button>
                  </div>
                </div>
                <div className="col-sm-4 text-center text-sm-left">
                  <div className="card-body pb-0 px-0 px-md-6">
                    <img src={dash_img} height="175" className="scaleX-n1-rtl" alt="Review Illustration" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {projects.map((project) => (
            <div className="col-lg-6" key={project.id}>
              <div className="card p-4 mb-4 rounded-4 shadow-sm">
                <div className="d-flex align-items-center border-bottom pb-3">
                  <img src={project.logo} alt={project.title} width="50" height="50" className="me-3 border p-1 rounded" />
                  <div className="w-100 d-flex justify-content-between">
                    <div>
                      <h5>
                        <NavLink to="/CompanyProfile" className="text-dark text-decoration-none">
                          {project.title}
                        </NavLink>
                      </h5>
                      <span className="card-text rating"><strong className="me-2">4.5</strong> <span className="text-warning">★★★★★</span> <span className="ms-3 small">(26 Reviews)</span></span>
                    </div>
                    <div>
                      <Button variant="outline-primary" size="sm" className="text-primary" onClick={() => handleEdit(project)}>Edit</Button>
                      <Button variant="danger" size="sm" className="ms-2" onClick={() => handleDelete(project)}>Delete</Button>
                    </div>
                  </div>
                </div>
                <p className="text-muted p-0 m-0 mt-3">{project.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Edit Side Panel */}
        <Offcanvas show={showEditPanel} onHide={() => setShowEditPanel(false)} placement="end">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Edit Review</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {selectedProject && (
              <Form>
                <Form.Group className="mb-4">
                  <Form.Label>Company Name</Form.Label>
                  <Form.Control type="text" name="company" value={selectedProject.title || ''} readOnly />
                </Form.Group>

                <Form.Group className="mt-4">
                  <Form.Label>Edit Your Review</Form.Label>
                  <Form.Control as="textarea" name="description" rows={3} value={selectedProject.description || ''} onChange={handleChange} required />
                </Form.Group>

                <Button variant="primary" onClick={handleSaveEdit} className="mt-3">Save Changes</Button>
              </Form>
            )}
          </Offcanvas.Body>
        </Offcanvas>

        {/* Delete Confirmation Modal */}
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Deletion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to delete this project?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
            <Button variant="danger" onClick={handleConfirmDelete}>Delete</Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </div>
          <Footer />
          </>
  );
};

export default MyReviews;
